import { BankSlipType } from './type'
import Visual from './Visual'

const BankSlip = ({ orderId }: BankSlipType) => {
  return <Visual orderId={orderId} />
}

export default BankSlip
